// extracted by mini-css-extract-plugin
export var dropdownContainer = "_qg-0";
export var leftAlign = "_qg-4";
export var listItem = "_qg-2";
export var listItemWrapper = "_qg-1";
export var operationText = "_qg-3";